<template>
  <div class="inform-cancellation">
    <div class="inform-cancellation__top">
      <button
        class="inform-cancellation__close"
        @click="$emit('close-cancel-subscription-modal')"
      >
        <span class="inform-cancellation__close--icon material-icons"
          >clear</span
        >
      </button>
    </div>
    <div class="inform-cancellation__bottom">
      <p class="inform-cancellation__title">We hate to see you go!</p>
      <p class="inform-cancellation__copy">
        You will have access to your account until {{ planExpiryDate }}. Are you
        sure you want to unsubscribe?
      </p>
    </div>
    <div class="inform-cancellation__actions">
      <button
        class="btn btn--primary"
        @click="$emit('close-cancel-subscription-modal')"
      >
        Nevermind
      </button>
      <button class="btn btn--secondary" @click="$emit('handle-confirm-click')">
        Yes, unsubscribe me
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformCancellation',
  props: {
    planExpiryDate: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.inform-cancellation {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: 0;
  margin: 0 auto;
  background: rgba(17, 17, 17, 1);
  width: 100%;
  min-height: 410px;
  border-radius: 24px;
  overflow: scroll;
  @include tablet {
    top: 5%;
    max-width: 600px;
    min-height: 368px;
    height: auto;
  }
  @include desktop {
    overflow: hidden;
  }
  @media screen and (max-height: 800px) {
    overflow: scroll;
    height: 100%;
    width: 100%;
  }
  &__top {
    position: relative;
    top: 25px;
    right: 25px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  &__close {
    width: 50px;
    height: 50px;
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: -5px;
    z-index: 2;
    &--icon {
      color: var(--white);
    }
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    color: var(--white);
    padding: 40px 45px 10px 40px;
    height: fit-content;
    @include tablet {
      padding: 0px 50px 0 50px;
    }
  }
  &__title {
    font-size: rem(40px);
    font-family: var(--font-bold);
    padding: 0;
    margin: 15px 0;
    line-height: rem(52px);
  }
  &__copy {
    font-size: rem(18px);
    line-height: rem(24px);
    font-weight: 500;
    color: var(--light-blue-gray);
    padding: 0;
    margin: 0;
    text-align: center;
  }
  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0px auto;
    padding: 0px 0 30px 0;
    gap: 20px;
    @include tablet {
      justify-content: center;
    }
  }
  &__cancel-btn {
    color: var(--black);
    border: 3px solid var(--orange);
    margin: 0 0 25px 0;
    padding: 10px 25px;
    font-weight: 700;
    &:hover {
      color: var(--white);
    }
  }
  &__confirm-btn {
    background: none;
    border: none;
    text-decoration: underline;
    font-size: rem(16px);
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
